module.exports = __webpack_public_path__ + "img/welcome.f8645001.png";